import axios from "axios";

export const productionUrl = "https://backoffice.mynober.nl";
export const developmentUrl = "https://backoffice.mynober.nl";
// export const developmentUrl = "http://localhost:8083";

export const rootUrl = process.env.NODE_ENV === "production" ? productionUrl : developmentUrl;

const _get = (url) => {
  return axios
    .get(rootUrl + url, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
    })
    .then((res) => {
      return Promise.resolve(res);
    })
    .catch((e) => {
      if ((e.response && e.response.status === 401) || (e.response && e.response.status === 403)) {
        localStorage.removeItem("access_token");
        window.location = "/login";
      } else {
        return Promise.reject(e);
      }
    });
};

const _put = (url, data) => {
  return axios
    .put(
      rootUrl + url,
      { data },
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      }
    )
    .then((res) => {
      return Promise.resolve(res);
    })
    .catch((e) => {
      if ((e.response && e.response.status === 401) || (e.response && e.response.status === 403)) {
        localStorage.removeItem("access_token");
        window.location = "/login";
      } else {
        return Promise.reject(e);
      }
    });
};

const _post = (url, data, contentType = "application/json;charset=UTF-8") => {
  const body = contentType === "application/json;charset=UTF-8" ? { data } : data;

  return axios
    .post(rootUrl + url, body, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": contentType,
      },
    })
    .then((res) => {
      return Promise.resolve(res);
    })
    .catch((e) => {
      if ((e.response && e.response.status === 401) || (e.response && e.response.status === 403)) {
        localStorage.removeItem("access_token");
        window.location = "/login";
      } else {
        return Promise.reject(e);
      }
    });
};

const _delete = (url, data) => {
  return axios
    .delete(rootUrl + url, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: { data: data },
    })
    .then((res) => {
      return Promise.resolve(res);
    })
    .catch((e) => {
      if ((e.response && e.response.status === 401) || (e.response && e.response.status === 403)) {
        localStorage.removeItem("access_token");
        window.location = "/login";
      } else {
        return Promise.reject(e);
      }
    });
};

export { _get, _put, _post, _delete };
